import AOS from 'aos';

window.addEventListener('DOMContentLoaded', function() {
  AOS.init({disable: 'mobile'});
  // timeOutFunctionId stores a numeric ID which is 
  // used by clearTimeOut to reset timer
  let timeOutFunctionId;

  function setLineHeight(action) {
    const textWraps = [...document.querySelectorAll('.text-wrap')];
    const body = document.body;
    const isHome = body.classList.contains('home')

    textWraps.forEach((item) => {
      let height = 0;
      let SiblingPrev = item.previousElementSibling;
      let introLine = item.querySelector('.intro-line');

      if(SiblingPrev && SiblingPrev.classList.contains('introduction__left-wrap')) {
        let diff = isHome ? 135 : 50;
        diff = action === 'resize' && !isHome ? 30 : diff;
        height = item.offsetHeight - (SiblingPrev.offsetHeight + diff);
      } else {
        let diff = isHome ? 10 : 10;
        height = item.offsetHeight - diff;
      }
      introLine.style.height = height + 'px';
    })
  }

  function hideEmptyParagraphs() {
    const container = document.querySelector('.introduction');
    if(container) {
      let paragraphs = [...container.getElementsByTagName('p')];
      paragraphs.forEach(p => {  
        if (p.textContent.trim().length === 0) {
          p.classList.add('is-empty');
        }
      })
    }
  }

  window.addEventListener('load', () => {
    setLineHeight()
    hideEmptyParagraphs()
  });

  window.addEventListener('resize', function() {
    AOS.init({disable: 'mobile'});

    // clearTimeOut() resets the setTimeOut() timer
    // due to this the function in setTimeout() is 
    // fired after we are done resizing
    clearTimeout(timeOutFunctionId);
    
    // setTimeout returns the numeric ID which is used by
    // clearTimeOut to reset the timer
    timeOutFunctionId = setTimeout(() => {
      setLineHeight('resize')
    }, 500);
  });

});


// WEBPACK FOOTER //
// ./scripts/modules/general.js